import React, {Component} from 'react';
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {withFirestore, firestoreConnect, isLoaded, isEmpty} from "react-redux-firebase";
import {connect} from "react-redux";

class AuthLoadingWrapper extends Component {
    render() {
        const {auth, profile} = this.props

        //console.log('auth wrapper')
        //console.log(this.props)

        if(isLoaded(auth) && isLoaded(profile)){
            return this.props.children
        } else {
            return <div>init loading...</div>
        }

    }
}

export default compose(
    connect(
        ({firebase: {auth, profile}, firestore:{status}}) => ({
            auth,
            profile,
            status
        })
    ),
)(AuthLoadingWrapper)